import { useState } from 'react';
import { Button, Dialog, Table } from '@dreamtree-org/twreact-ui';
import { Ruler } from 'lucide-react';
import { chartTable } from '../lib/sizeChart';

/**
 * The listing's size chart (MERCH-88): its brand's chart for its type (lib/catalog/sizeCharts withSizeCharts).
 * Drawn inside the buy box under the size picker: landing-kit 0.9.0's PRODUCT_SLOTS has no `size_chart` slot of
 * its own yet (a landing-kit ticket), so the buy box carries it. Nothing when the listing has no chart.
 */
export default function SizeChart({ chart }) {
  const [open, setOpen] = useState(false);
  const table = chartTable(chart);
  if (!table) return null;
  return (
    <div data-testid="size-chart">
      <Button size="sm" variant="ghost" leftIcon={<Ruler size={16} />} onClick={() => setOpen(true)}>Size chart</Button>
      <Dialog isOpen={open} onClose={() => setOpen(false)} title={table.title} size="lg">
        <div className="space-y-3">
          <div className="overflow-x-auto">
            <Table
              data={table.data}
              columns={table.columns}
              sortable={false}
              showSerial={false}
              withAction={false}
              showToolbar={false}
              showColumnPicker={false}
              showLimitSelector={false}
              showReloadButton={false}
              wrapCells
            />
          </div>
          {table.note ? <p className="text-sm opacity-80">{table.note}</p> : null}
        </div>
      </Dialog>
    </div>
  );
}
